
import { Bar } from "react-chartjs-2";
import { useMemo } from "react";

export default function ChartSimple({ stats, title, type }) {
  const chartData = useMemo(() => {
    const filteredEntries = Object.entries(stats)
    .filter(([_, value]) => value >= 100);
  const labels = filteredEntries.map(([key]) => key);
  const values = filteredEntries.map(([_, value]) => value);
    const generateColor = (i) => {
    const palette = [
        "#1abc9c",
        "#3498db",
        "#9b59b6",
        "#e67e22",
        "#e74c3c",
        "#2ecc71",
        "#f1c40f",
        "#34495e",
    ];
    return palette[i % palette.length];
    };

    const max = Math.max(...values);
    const backgroundColor = values
    .map(v => {
        const ratio = v / max;

        if (ratio > 0.75) return "rgba(75, 192, 192, 0.8)";     // cao
        if (ratio > 0.4) return "rgba(255, 205, 86, 0.8)";     // trung bình
        return "rgba(255, 99, 132, 0.8)";                      // thấp
    });

    return {
      labels,
      datasets: [
        {
          label: title,
          data: values,
          borderWidth: 1,
          backgroundColor: type == "raw" ? labels.map((_, i) => generateColor(i)) : backgroundColor
        },
      ],
    };
  }, [stats, title]);

  const options = {
    indexAxis: "x", // ⭐ QUAN TRỌNG → horizontal
    responsive: true,
    plugins: {
      legend: {
       labels: {
            font: {
              size: 20,
            },
      },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            `${ctx.label}: ${ctx.raw.toLocaleString()}`,
        },
      },
    },
        },
    scales: {
      x: {
        ticks: {
          // callback: (value) => value.toLocaleString(),
          autoSkip: false
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
}
